// ============================================================
//  CENTRAL DE CONTEÚDO — Intensivo Transferência UNESP
//  Altere aqui: preços, datas, links, vagas, FAQ, etc.
// ============================================================

// >>> LINKS DOS CTAs (edite facilmente) <<<
export const CTA_LINKS = {
  // Link principal de checkout / WhatsApp (EDITÁVEL)
  checkout: "https://transferenciaacademy.classbuild.com/payments/classpay-asaas/purchase/intensivo-unesp",
  // Link da Aula 0 gratuita (rola para o formulário na página)
  aula0: "#aula-zero",
  // WhatsApp geral / suporte
  whatsapp: "https://wa.me/5517976045242",
  whatsappSupport: "https://wa.me/5517976045242?text=Ol%C3%A1!%20Tenho%20uma%20d%C3%BAvida%20sobre%20o%20Intensivo%20Transfer%C3%AAncia%20UNESP.",
  instagram: "https://instagram.com/transferencia_academy",
};

export const SUPPORT = {
  label: "SUPORTE",
  title: "Ficou com alguma dúvida?",
  text: "Nossa equipe está pronta para te ajudar. Fale diretamente pelo WhatsApp e tire todas as suas dúvidas sobre o Intensivo Transferência UNESP.",
  cta: "FALAR NO WHATSAPP",
  phoneLabel: "+55 17 97604-5242",
};

export const BRAND = {
  name: "TRANSFERÊNCIA ACADEMY",
  submark: "INTENSIVO UNESP",
  tagline: "Preparação estratégica para transferência em Medicina.",
  logo: "/logo.png",
};

export const NAV_LINKS = [
  { label: "O Intensivo", href: "#metodo" },
  { label: "Como funciona", href: "#metodo" },
  { label: "Conteúdo", href: "#semanas" },
  { label: "O que você recebe", href: "#recebe" },
  { label: "Investimento", href: "#investimento" },
];

export const HERO = {
  badge: "MÓDULO EXCLUSIVO • TRANSFERÊNCIA UNESP",
  headlineLines: [
    "Sua preparação para a",
    "transferência em Medicina",
    "da UNESP começa aqui.",
  ],
  subheadline:
    "8 semanas de preparação estratégica para transformar o edital em um plano de estudo objetivo, priorizar os conteúdos certos e treinar para converter estudo em acertos.",
  ctaPrimary: "QUERO ME PREPARAR PARA A UNESP",
  ctaSecondary: "CONHECER O INTENSIVO",
  microline: "Aulas ao vivo • Questões • Materiais • Simulado final",
};

// Dados demonstrativos do dashboard (apenas ilustrativos — não são promessa de resultado)
export const DASHBOARD = {
  progress: 68,
  questions: 247,
  accuracy: 82,
  simulados: 3,
  nextClass: "Sistema Nervoso",
  studyHours: 46,
  weekly: [
    { s: "S1", v: 40 }, { s: "S2", v: 52 }, { s: "S3", v: 58 },
    { s: "S4", v: 61 }, { s: "S5", v: 70 }, { s: "S6", v: 74 },
    { s: "S7", v: 79 }, { s: "S8", v: 82 },
  ],
  byArea: [
    { area: "Célula", v: 88 },
    { area: "Neuro", v: 74 },
    { area: "Cardio", v: 81 },
    { area: "Respir.", v: 69 },
    { area: "Saúde Col.", v: 90 },
  ],
  recurringErrors: [
    { label: "Transporte de membrana", pct: 34 },
    { label: "Potencial de ação", pct: 28 },
    { label: "Ciclo cardíaco", pct: 22 },
  ],
  pendingReviews: 7,
};

export const IMPACT = [
  { value: 8, suffix: "", label: "SEMANAS", sub: "Preparação estratégica" },
  { text: "AULAS", label: "AO VIVO", sub: "Uma por semana" },
  { value: 1, suffix: "", label: "OBJETIVO", sub: "Transferência em Medicina UNESP" },
];

export const PROBLEM = {
  title: "O problema não é estudar mais. É saber o que priorizar.",
  text: "O edital da transferência reúne uma grande quantidade de conteúdos. O desafio é entender quais temas merecem maior atenção, organizar o estudo e transformar conhecimento em desempenho na prova.",
  flow: ["EDITAL", "PRIORIZAÇÃO", "ESTUDO", "QUESTÕES", "REVISÃO", "SIMULADO", "PROVA"],
};

export const METHOD = {
  title: "Do edital à prova.",
  subtitle: "Uma preparação construída para transformar conteúdo em estratégia.",
  steps: [
    { n: "01", title: "MAPA DA PROVA", desc: "Entenda o que é cobrado e onde estão os pontos importantes." },
    { n: "02", title: "AULAS", desc: "Conteúdo direcionado aos temas relevantes." },
    { n: "03", title: "QUESTÕES", desc: "Resolva e compreenda questões relacionadas ao conteúdo." },
    { n: "04", title: "REVISÃO", desc: "Registre erros e revise os pontos que precisam de reforço." },
  ],
};

export const RECEIVE = {
  title: "Não são apenas aulas.",
  subtitle: "Você recebe uma estrutura completa de preparação para as 8 semanas.",
  items: [
    { icon: "Video", title: "AULAS AO VIVO FOCADAS PARA UNESP", desc: "Encontros ao vivo semanais." },
    { icon: "BookOpen", title: "MATERIAL DIDÁTICO", desc: "PDFs, resumos e mapas mentais." },
    { icon: "ListChecks", title: "BANCO DE QUESTÕES", desc: "Questões selecionadas e resolução comentada." },
    { icon: "CalendarDays", title: "CRONOGRAMA SEMANAL", desc: "Plano de estudos para organizar sua preparação entre os encontros." },
    { icon: "FileCheck", title: "SIMULADOS", desc: "Simulados com foco para UNESP." },
    { icon: "TrendingUp", title: "CORREÇÃO ESTRATÉGICA", desc: "Análise de desempenho e identificação dos pontos de revisão." },
    { icon: "Flag", title: "RETA FINAL", desc: "Revisão das prioridades e estratégia de prova." },
  ],
};

export const WEEKS = [
  { n: "01", title: "A Célula I", desc: "Bioquímica celular, proteínas, lipídios, carboidratos, membrana plasmática, transporte, organelas, metabolismo, citoesqueleto, matriz extracelular e comunicação celular." },
  { n: "02", title: "A Célula II", desc: "DNA, RNA, replicação, transcrição, tradução, ciclo celular, mitose, meiose, genética, gametogênese, morte celular, histologia e embriologia." },
  { n: "03", title: "Sistema Nervoso", desc: "Neuroanatomia, SNC, SNP, medula, tronco encefálico, cerebelo, córtex, núcleos da base, tálamo, hipotálamo, meninges, líquor e vascularização." },
  { n: "04", title: "Neurofisiologia + Órgãos dos Sentidos", desc: "Potencial de ação, sinapses, neurotransmissores, vias sensitivas e motoras, sistema nervoso autônomo, visão, audição, equilíbrio, olfato e gustação." },
  { n: "05", title: "Sistema Cardiovascular", desc: "Anatomia cardíaca, circulação, vasos, eletrofisiologia, ciclo cardíaco, débito cardíaco, pressão arterial, hemodinâmica e regulação cardiovascular." },
  { n: "06", title: "Sistema Respiratório + Hematológico", desc: "Anatomia respiratória, mecânica, volumes, ventilação, perfusão, relação V/Q, difusão, transporte de gases, controle respiratório, hematopoiese, células sanguíneas, hemostasia e coagulação." },
  { n: "07", title: "Saúde Coletiva + Saúde e Sociedade", desc: "SUS, princípios e diretrizes, APS, território, epidemiologia, indicadores, vigilância, políticas públicas, processo saúde-doença, determinantes sociais, relação médico-paciente, cuidado, desigualdades e aspectos socioantropológicos." },
  { n: "08", title: "Restante do edital + Reta Final", desc: "Aparelho locomotor, método e raciocínio científico, comunicação e anamnese, cuidados de enfermagem, tegumentar, introdução à medicina, fundamentos históricos e filosóficos, extensão universitária, suporte básico de vida e estratégia de prova." },
];

export const COMPARISON = {
  title: "Uma preparação diferente de um cursinho generalista.",
  left: {
    title: "ESTUDO SEM DIREÇÃO",
    items: ["Muito conteúdo", "Difícil saber prioridades", "Estudo pouco direcionado", "Falta de acompanhamento", "Pouca clareza sobre evolução"],
  },
  right: {
    title: "INTENSIVO TRANSFERÊNCIA UNESP",
    items: ["Conteúdo direcionado", "Priorização", "Questões", "Cronograma", "Simulado", "Análise de desempenho", "Estratégia de prova"],
  },
};

export const AULA0 = {
  title: "Antes de comprar, entenda como a prova funciona.",
  subtitle: "Participe da Aula 0 gratuita e descubra o que realmente cai na prova de transferência da UNESP e como organizar sua preparação.",
  points: [
    "Como funciona a prova",
    "Distribuição das questões",
    "Mapa de prioridades",
    "Aula demonstrativa",
    "Questões",
    "Como funciona uma preparação de 8 semanas",
  ],
  cta: "QUERO PARTICIPAR DA AULA GRATUITA",
  // EDITÁVEL — defina quando houver data confirmada
  date: "Data a ser divulgada",
  time: "Horário a ser divulgado",
};

export const EXCLUSIVITY = {
  title: "Uma preparação específica para uma prova específica.",
  text: "O Intensivo Transferência UNESP foi desenvolvido exclusivamente para candidatos à transferência externa em Medicina da UNESP.",
  pillars: ["8 SEMANAS", "1 MÉTODO", "1 OBJETIVO"],
};

export const PRICING = {
  title: "Comece sua preparação.",
  founderLabel: "2º LOTE",
  founderPrice: "R$ 1.197",
  founderNote: "Condição exclusiva para a primeira turma.",
  vagas: "20 vagas para a turma fundadora",
  cta: "QUERO GARANTIR MINHA VAGA",
  lots: [
    { label: "Lote fundador", price: "R$ 997", current: false, past: true },
    { label: "2º lote", price: "R$ 1.197", current: true },
    { label: "3º lote", price: "R$ 1.397", current: false },
    { label: "Preço oficial", price: "R$ 1.497", current: false },
  ],
  checklist: [
    "Aulas ao vivo", "Material didático", "Resumos", "Mapas mentais",
    "Banco de questões", "Questões comentadas", "Cronograma semanal",
    "Simulado final de 100 questões",
    "Correção estratégica", "Reta final",
  ],
};

export const FAQ = [
  { q: "Para quem é o Intensivo?", a: "O Intensivo Transferência UNESP foi desenvolvido para candidatos à transferência externa em Medicina da UNESP que buscam uma preparação estratégica e direcionada ao que é cobrado na prova." },
  { q: "Quantas semanas dura a preparação?", a: "São 8 semanas de preparação estratégica, com uma aula ao vivo por semana e um plano de estudos que conecta conteúdo, questões, revisão e simulado." },
  { q: "Como funcionam as aulas?", a: "As aulas são ao vivo, uma por semana, com aproximadamente 2 a 3 horas cada, direcionadas aos temas relevantes do edital." },
  { q: "As aulas ficam gravadas?", a: "Essa informação será divulgada em breve. (Campo editável — atualize quando definido.)" },
  { q: "O que está incluído?", a: "Aulas ao vivo, material didático, resumos, mapas mentais, banco de questões comentadas, cronograma semanal, simulado final de 100 questões, correção estratégica e reta final." },
  { q: "Existe banco de questões?", a: "Sim. Você tem acesso a questões selecionadas com resolução comentada, além de um banco de erros para registrar e revisar os pontos que precisam de reforço." },
  { q: "Existe simulado?", a: "Sim. Ao final da preparação há um simulado completo com 100 questões, seguido de correção estratégica e análise de desempenho." },
  { q: "Como funciona o lote fundador?", a: "O lote fundador é uma condição exclusiva para a primeira turma, com 20 vagas sugeridas. Conforme as vagas forem preenchidas, o valor evolui para os lotes seguintes." },
  { q: "Qual é a plataforma utilizada?", a: "Essa informação será divulgada em breve. (Campo editável — atualize quando definido.)" },
];

export const FINAL_CTA = {
  kicker: "TRANSFERÊNCIA ACADEMY • INTENSIVO UNESP",
  title: "Você não precisa estudar tudo. Precisa estudar com estratégia.",
  subtitle: "8 semanas para transformar o edital em preparação, questões, revisão e desempenho.",
  cta: "QUERO ME PREPARAR PARA A UNESP",
  microline: "8 semanas • Aulas ao vivo • Questões • Simulado • Estratégia",
};

export const FOOTER_LINKS = [
  { label: "Início", href: "#topo" },
  { label: "O Intensivo", href: "#metodo" },
  { label: "Conteúdo", href: "#semanas" },
  { label: "Investimento", href: "#investimento" },
  { label: "Contato", href: "#contato" },
];
